'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _metanearSdkJs = require('metanear-sdk-js');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  defaultProfileUrl: _propTypes2.default.string,
  displayName: _propTypes2.default.string,
  profileUrl: _propTypes2.default.string,
  bio: _propTypes2.default.string,
  onFetch: _propTypes2.default.func,
  forceShow: _propTypes2.default.bool
};

var defaultProps = {
  defaultProfileUrl: null,
  styles: {
    profile: {
      whiteSpace: 'nowrap',
      display: 'inline-block'
    },
    profileImage: {
      height: '3em',
      width: '3em',
      borderRadius: '50%',
      verticalAlign: 'middle'
    },
    profileName: {
      overflowY: 'hidden',
      marginLeft: '0.5em',
      verticalAlign: 'middle'
    },
    profileDisplayName: {},
    profileAccountId: {
      color: '#999'
    }
  }
};

var profileAppId = 'profile';

var Profile = function (_React$Component) {
  _inherits(Profile, _React$Component);

  function Profile(props) {
    _classCallCheck(this, Profile);

    var _this = _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).call(this, props));

    _this.state = {
      displayName: '',
      profileUrl: null,
      bio: '',
      loading: false,
      found: false
    };
    var nearConfig = _this.props.nearConfig || window.nearConfig || {
      networkId: 'default',
      nodeUrl: 'https://rpc.nearprotocol.com',
      walletUrl: 'https://wallet.nearprotocol.com'
    };

    if (!window.profileComponentCache) {
      window.profileComponentCache = {
        profileCache: {},
        app: new _metanearSdkJs.MetaNearApp(profileAppId, null, nearConfig)
      };
      window.profileComponentCache.app.init();
    }

    _this.profileCache = window.profileComponentCache.profileCache;
    _this.app = window.profileComponentCache.app;
    return _this;
  }

  _createClass(Profile, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.props.accountId && this.app.init().then(function () {
        return _this2.updateProfile(_this2.props.accountId);
      });
    }
  }, {
    key: 'fetchProfile',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(accountId) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(accountId in this.profileCache)) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return this.profileCache[accountId];

              case 3:
                return _context.abrupt('return', _context.sent);

              case 6:
                console.log("Fetching profile for " + accountId);
                this.profileCache[accountId] = Promise.all([this.app.getFrom(accountId, 'displayName'), this.app.getFrom(accountId, 'profileUrl'), this.app.getFrom(accountId, 'bio')]).then(function (values) {
                  return {
                    accountId: accountId,
                    displayName: values[0] || "",
                    profileUrl: values[1],
                    bio: values[2] || ""
                  };
                }).catch(function (e) {
                  return false;
                });
                _context.next = 10;
                return this.profileCache[accountId];

              case 10:
                return _context.abrupt('return', _context.sent);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchProfile(_x) {
        return _ref.apply(this, arguments);
      }

      return fetchProfile;
    }()
  }, {
    key: 'updateProfile',
    value: function updateProfile(accountId) {
      var _this3 = this;

      this.setState({
        displayName: "",
        profileUrl: null,
        bio: "",
        loading: true,
        found: false
      });
      this.fetchProfile(this.props.accountId).then(function (profile) {
        if (profile) {
          _this3.setState({
            displayName: profile.displayName,
            profileUrl: profile.profileUrl,
            bio: profile.bio,
            loading: false,
            found: true
          });
        } else {
          _this3.setState({
            loading: false,
            found: false
          });
        }
        _this3.props.onFetch && _this3.props.onFetch(profile);
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this4 = this;

      if (this.props.accountId !== prevProps.accountId) {
        this.app.init().then(function () {
          return _this4.updateProfile(_this4.props.accountId);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var displayName = this.props.displayName || this.state.displayName;
      var profileUrl = this.props.profileUrl || this.state.profileUrl || this.props.defaultProfileUrl;
      var bio = this.props.bio || this.state.bio;
      var accountId = this.props.accountId;
      var styles = this.props.styles;

      return this.state.loading ? _react2.default.createElement(
        'div',
        { style: styles.profile },
        _react2.default.createElement(
          'div',
          { className: 'spinner-grow', role: 'status' },
          _react2.default.createElement(
            'span',
            { className: 'sr-only' },
            'Loading...'
          )
        )
      ) : this.state.found || this.props.forceShow ? _react2.default.createElement(
        'div',
        { style: styles.profile, title: bio },
        _react2.default.createElement('img', { style: styles.profileImage, src: profileUrl, alt: 'Profile @' + accountId }),
        _react2.default.createElement(
          'span',
          { style: styles.profileName },
          _react2.default.createElement(
            'span',
            { style: styles.profileDisplayName },
            displayName
          ),
          _react2.default.createElement(
            'span',
            { style: styles.profileAccountId },
            "(@" + accountId + ")"
          )
        )
      ) : null;
    }
  }]);

  return Profile;
}(_react2.default.Component);

Profile.propTypes = propTypes;
Profile.defaultProps = defaultProps;

exports.default = Profile;